import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataShareService {

    private dataMap : Map<string, any> = new Map<string, any>();
    private dataBehaviorSubject = new BehaviorSubject(this.dataMap);
    data = this.dataBehaviorSubject.asObservable();
    
    constructor() { }
  
    add(key: string, data: any) {
      this.dataMap.set(key,data);
      this.dataBehaviorSubject.next(this.dataMap);
    }

    remove(key: string) {
        this.dataMap.delete(key);
        this.dataBehaviorSubject.next(this.dataMap);
    }

    get(key: string): any {
        return this.dataBehaviorSubject.getValue().get(key);
    }

    clear() {
        this.dataMap.clear(); 
        this.dataBehaviorSubject.next(this.dataMap);
    }

}